// Per-device view counts by release id, so a banner a merchant has already
// scrolled past twice in this browser stops coming back
const STORAGE_KEY = "blog-sync.release-views"

function read(): Record<string, number> {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}")
  } catch {
    return {}
  }
}

export const releaseViewsOnDevice = (id?: string): number =>
  id ? read()[id] ?? 0 : 0

export const recordReleaseView = (id: string): void => {
  try {
    const views = read()
    views[id] = (views[id] ?? 0) + 1
    localStorage.setItem(STORAGE_KEY, JSON.stringify(views))
  } catch {
    // private mode or blocked storage: the banner just keeps showing here
  }
}
